import * as React from 'react';
import queryString from 'query-string';
import styles from './Map.module.css';
import TokenService from '~services/TokenService';
import { WEBVIEW_MAP_URL } from '~config/map';

export interface MapProps {
  page?:
    | 'detail'
    | 'indoor-map'
    | 'beacon-map'
    | 'map-position'
    | 'geofence-editor'
    | 'installer-validate-map'
    | 'outdoor-draw-tool'
    | 'insert-markers-indoor'
    | 'draw-tool'
    | 'zone-selector';
  lat?: number;
  long?: number;
  accuracy?: number;
  siteId?: number | string;
  withBeaconMac?: boolean;
  withBeaconCoordinates?: boolean;
  ignoreMapClick?: boolean;
  height?: number | string;
  planeId?: number | string;
  floorSelect?: boolean;
  type?: string;
  planeUuid?: string;
  zoneUuid?: string;
  safeAreaTop?: number;
  showRooms?: boolean;
  showRoomLabels?: boolean;
  withGoBack?: boolean;
  canInsertMarker?: boolean;
  zoom?: number;
  onFloorLoaded?: (e: any) => void;
}

const Map = React.forwardRef<HTMLIFrameElement, MapProps>(
  (
    {
      page,
      planeId,
      lat,
      long,
      accuracy,
      siteId,
      ignoreMapClick,
      planeUuid,
      floorSelect,
      height,
      type,
      withBeaconMac,
      zoneUuid,
      withBeaconCoordinates,
    },
    ref
  ) => {
    const MapPath = React.useMemo(() => {
      const query = queryString.stringify({
        planeId,
        page,
        lat,
        long,
        accuracy,
        siteId,
        ignoreMapClick,
        planeUuid,
        floorSelect,
        zoneUuid,
        type,
        withBeaconMac,
        withBeaconCoordinates,
        token: TokenService.token?.token,
        endpoint: TokenService.baseUrl.apiUrl,
      });
      return `${WEBVIEW_MAP_URL}?${query}`;
    }, []);

    return (
      <div className={styles.MapEmbed}>
        <iframe key={MapPath} ref={ref} style={{ height }} src={MapPath} />
      </div>
    );
  }
);

export default Map;
